// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const DispatchClearUploadedFileStatus: Handler = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/ClearUploadedFileStatus",
    });
};

export const chain = [DispatchClearUploadedFileStatus];

const clearUploadedFileStatus = createHandlerChainRunner(chain, "ClearUploadedFileStatus");
export default clearUploadedFileStatus;
